import React, { useState } from "react";
import styled from "styled-components";

import { Text } from "../../../../components";
import ModalTableCheckboxSearch from "../../../../components/ModalTableCheckboxSearch";
import { Colors } from "../../../../constants/Colors";
import {
  agentTypeOptionListERP,
  agentTypeERP,
} from "../../../../constants/order";
import { agentTableHeaderV2, agentTableKey } from "./constants";
import { Box, Tooltip, withStyles } from "@material-ui/core";

const AddressWrapper = styled.div`
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
`;

const AgentWrapper = styled.div`
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;

  > span {
    color: #9a9a9a;
  }
`;

export const TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 4px 0;
`;

export const Tag = styled.div`
  border: 1px solid ${Colors.GRAY};
  border-radius: 16px;
  padding: 4px 8px;
  color: ${Colors.GRAY_DARKER};
  font-size: 14px;
  margin: 4px 4px 4px 0;
`;

const StyledTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: Colors.GRAY_LIGHTEST,
  },
})(Tooltip);

const AgentsModalTable = ({
  handleRefresh,
  agentSelectedList = [],
  ...props
}) => {
  const [isRefresh, setIsRefresh] = useState(false);

  const columnConfig = {
    [agentTableKey.AGENT]: {
      order: 1,
      width: 195,
    },
    [agentTableKey.CITY]: {
      order: 2,
      width: 185,
    },
    [agentTableKey.TAG]: {
      order: 3,
      width: 205,
    },
  };

  const components = {
    [agentTableKey.AGENT]: (fieldData, data, rowIndex) => {
      const rowData = data[rowIndex];
      return (
        <Tooltip title={rowData.name} placement="top" arrow>
          <AgentWrapper>
            {rowData.name}
            <br />
            <span>{`${rowData.customerCode || ""}`}</span>
          </AgentWrapper>
        </Tooltip>
      );
    },
    [agentTableKey.CITY]: (fieldData, data, rowIndex) => {
      const rowData = data[rowIndex];
      const cityAndState = `${rowData.city} - ${rowData.uf}`;

      return (
        <Tooltip title={cityAndState} placement="top" arrow>
          <AddressWrapper>
            <Text>{cityAndState}</Text>
          </AddressWrapper>
        </Tooltip>
      );
    },
    [agentTableKey.TAG]: (tags) => {
      const visibleCategories = tags.slice(0, 1);
      const hiddenCategories = tags.slice(1);

      if (tags.length > 1) {
        return (
          <>
            <Box
              maxHeight={48}
              overflow="hidden"
              display="flex"
              flexWrap="wrap"
              alignItems="center"
            >
              {visibleCategories.map((tag) => (
                <Tag key={`${props.name}-${tag.id}`}>{tag.name}</Tag>
              ))}
              <StyledTooltip
                title={
                  <Box display="flex" flexWrap="wrap">
                    {hiddenCategories.map((tag) => (
                      <Tag key={`${props.name}-${tag.id}`}>{tag.name}</Tag>
                    ))}
                  </Box>
                }
                arrow
                interactive
                placement="top"
              >
                {hiddenCategories.length > 0 && (
                  <Tag>{`+${hiddenCategories.length}`}</Tag>
                )}
              </StyledTooltip>
            </Box>
          </>
            
        );
      } else {
        return (
          <TagWrapper>
            {tags.map((tag) => (
              <Tag key={`${props.name}-${tag.id}`}>{tag.name}</Tag>
            ))}
          </TagWrapper>
        );
      }
    },
  };

  return (
    <ModalTableCheckboxSearch
      title="Selecione um representante"
      placeholder={(option) =>
        agentTypeERP.NAME === option.type
          ? "Nome do representante"
          : "Selecionar categoria"
      }
      tableColumnConfig={columnConfig}
      tableComponents={components}
      searchTypeList={agentTypeOptionListERP}
      tableHandleHeaderTitle={(key) => agentTableHeaderV2[key]}
      handleRefresh={() => {
        handleRefresh();
        setIsRefresh(true);
      }}
      isRefresh={isRefresh}
      disableConfirm
      agentSelectedList={agentSelectedList}
      {...props}
    />
  );
};

export default AgentsModalTable;
